// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SFyTnmaavlxYgPN7sii3C","searchIcon":"_1iM1PpnKbt1cIpI6WYmeGZ"};